module.exports = __webpack_public_path__ + "img/sdk-pilot-programme-hero.a190ce6b.svg";